import type { Faq, FaqStandalone } from './schemas'

export abstract class FaqRepository {
  abstract getAll(langCode: string): Promise<Faq[]>
  abstract getStandaloneBySlug(
    langCode: string,
    slug: string,
  ): Promise<FaqStandalone>
}

export interface FaqResponse {
  category: string
  questions: Array<{
    answer: string
    name: string
    slug: string
  }>
}

export interface FaqStandaloneResponse {
  answer: string
  description: string
  question: string
}

export interface FaqStandaloneEvent {
  type: 'FETCH_STANDALONE'
  slug: string
}

export interface FaqAllEvent {
  type: 'FETCH_ALL'
}
